"use client";

import { Suspense } from "react";
import { useMedia } from "react-use";
import Link from "next/link";
import type { ButtonProps } from "app/_components/components/Button";
import { Button } from "app/_components/components/Button";
import { BaseLink } from "./BaseLink";
import { useTranslations } from "i18n";
import { mediaQuery } from "utils";

export function RegistrationDownloadLink({
  referralCode,
  ...props
}: {
  referralCode?: string;
} & ButtonProps) {
  const t = useTranslations("common");
  const isTablet = useMedia(mediaQuery.tabletSmDown, false);

  const label = isTablet ? t("download") : t("getStarted");
  const href = isTablet
    ? "https://geminiexchange.app.link/fL2oDHN39pb"
    : "https://exchange.gemini.com/register";

  return (
    <Suspense
      fallback={
        <Button
          asChild
          className="!bg-[#F9A631] !text-black hover:!bg-[#F9A631]/60 active:!bg-[#F9A631]/60"
          id="register-exchange"
          variant="theme"
          {...props}
        >
          <Link href={href}>{label}</Link>
        </Button>
      }
    >
      <BaseLink
        className="!bg-[#F9A631] !text-black hover:!bg-[#F9A631]/60 active:!bg-[#F9A631]/60"
        href={href}
        id="register-exchange"
        label={label}
        referralCode={referralCode}
        {...props}
      />
    </Suspense>
  );
}
